import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCostExplorer } from '../../services/api/costExplorerApi';

// ─── Async Thunk ─────────────────────────────────────────────────────────────

export const fetchCostExplorer = createAsyncThunk(
  'costExplorer/fetch',
  async (params = {}, { rejectWithValue }) => {
    try {
      const data = await getCostExplorer(params);
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: 'Failed to fetch cost explorer data' }
      );
    }
  }
);

// ─── Initial State ───────────────────────────────────────────────────────────

const initialState = {
  data: null,
  loading: false,
  error: null,
};

// ─── Slice ───────────────────────────────────────────────────────────────────

const costExplorerSlice = createSlice({
  name: 'costExplorer',
  initialState,
  reducers: {
    resetCostExplorer(state) {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCostExplorer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCostExplorer.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCostExplorer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to fetch cost data';
      });
  },
});

export const { resetCostExplorer } = costExplorerSlice.actions;

export default costExplorerSlice.reducer;
